import dynamicYieldClient from 'src/utils/dynamicYield/dynamicYieldClient'

import { ensureDYCookies } from './dynamicYieldCookies'
import type { DynamicYieldEngagement } from './types/dynamicYieldTypes'

export default async function dynamicYieldEngagement(
  engagements: DynamicYieldEngagement[]
) {
  try {
    const { dyid, dyidServer, sessionId } = await ensureDYCookies()

    const eventsViewData = {
      user: { active_consent_accepted: true, dyid_server: dyidServer, dyid },
      session: { dy: sessionId },
      context: { channel: 'WEB' },
      engagements,
    }

    const result = await dynamicYieldClient.post('/engagement', eventsViewData)

    console.info(`Dynamic Yield (${engagements[0].type}): `, result?.data)
  } catch (error) {
    console.error(
      `Error sending Dynamic Yield page (${engagements[0].type}): `,
      error
    )
  }
}
